export * from "./date"
export * from './validate'


//采用max方式的的metric
export const maxMetric = ['pod.network.rx_rate', 'pod.network.tx_rate',
  'container.cpu.usage_for_request', 'container.cpu.usage_for_limit',
  'container.memory.usage', 'container.memory.usage_for_request', 'container.memory.usage_for_limit', 'container.cpu.usage',
  'container.disk.io_read_bytes', 'container.disk.io_write_bytes', 'container.disk.io_read_bytes_rate', 'container.disk.io_write_bytes_rate'];
//采用sum方式的metric
export const sumMetric = ['pod.network.rx', 'pod.network.tx'];
//采用avg方式的metric
export const avgMetric = ['rds.', 'postgresql.', 'sqlserver.', 'kingdb.', 'drds.', 'kcs.']

export const methodObject = {
  avg: '平均值',
  max: '最大值',
  min: '最小值',
  sum: '求和值'
}

// 大小 - 周期环比
export const compareObject = {
  GreaterThanLastPeriod: '周期环比上涨',
  LessThanLastPeriod: '周期环比下降'
}

// 指标统计方法
export const targetMethod = [
  {
    label: "最大值",
    value: "max"
  },
  {
    label: "最小值",
    value: "min"
  },
  {
    label: "平均值",
    value: "avg"
  },
  {
    label: "求和值",
    value: "sum"
  },
  {
    label: "计数",
    value: "samplecount"
  }
]
// 指标统计周期
export const targetPeriod = [
  {
    label: "1分钟",
    value: 1
  },
  {
    label: "5分钟",
    value: 5
  },
  {
    label: "15分钟",
    value: 15
  },
  {
    label: "1小时",
    value: 60
  }
]

// 记数次数
export const CountData = Array.from({ length: 10 }, (v, i) => i + 1)

// 统计方法dict
export const MethodOp = [
  {
    key: '>=',
    value: '大于等于',
    semantic: '大于等于'
  },
  {
    key: '>',
    value: '大于',
    semantic: '大于'
  },
  {
    key: '<=',
    value: '小于等于',
    semantic: '小于等于'
  },
  {
    key: '=',
    value: '等于',
    semantic: '等于'
  },
  {
    key: '!=',
    value: '不等于',
    semantic: '不等于'
  }
]